import React, { useState } from 'react';
import { Form, Input, Button, message, Typography, Card } from 'antd';
import { auth } from '../../firebase/config';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { useNavigate, Link } from 'react-router-dom';
import { MailOutlined, LockOutlined } from '@ant-design/icons';

const { Title } = Typography;

const Login = ({ messageApi }) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const styles = {
    container: {
      minHeight: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: '#f0f2f5',
      padding: '20px',
    },
    card: {
      width: '100%',
      maxWidth: '400px',
      boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
      borderRadius: '8px',
    },
    header: {
      textAlign: 'center',
      marginBottom: '32px',
    },
    form: {
      padding: '24px',
    },
    registerLink: {
      textAlign: 'center',
      marginTop: '16px',
    }
  };

  const onFinish = async (values) => {
    try {
      setLoading(true);
      await signInWithEmailAndPassword(auth, values.email, values.password);
      messageApi.success({
        content: 'Login successful!',
        duration: 3,
      });
      navigate('/');
    } catch (error) {
      messageApi.error({
        content: 'Invalid email or password. Please try again.',
        duration: 3,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <Card style={styles.card}>
        <div style={styles.header}>
          <Title level={2}>Login</Title>
        </div>
        <Form
          name="login"
          onFinish={onFinish}
          style={styles.form}
          initialValues={{
            email: 'dummy@gmail.com',
            password: '123456'
          }}
        >
          <Form.Item
            name="email"
            rules={[{ required: true, message: 'Please input your email!' }]}
          >
            <Input 
              prefix={<MailOutlined />}
              placeholder="Email"
              size="large"
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: 'Please input your password!' }]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="Password"
              size="large"
            />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" size="large" block loading={loading}>
              Login
            </Button>
          </Form.Item>
        </Form>
        <div style={styles.registerLink}>
          <Link to="/register">Don't have an account? Register now!</Link>
        </div>
      </Card>
    </div>
  );
};

export default Login;
